(function () {
  var W = '.smart-tabs-wrapper';

  function clampH() { return window.innerWidth >= 768 ? 230 : 170; }

  function setAttr(el, k, v) { if (el.getAttribute(k) !== v) el.setAttribute(k, v); }
  function setCls(el, c, on) { if (el.classList.contains(c) !== on) el.classList.toggle(c, on); }

  function setupMore(block) {
    if (block.querySelector('.st-rm-inner')) return;
    var inner = document.createElement('div');
    inner.className = 'st-rm-inner';
    while (block.firstChild) inner.appendChild(block.firstChild);
    block.appendChild(inner);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'st-rm-btn';
    btn.textContent = 'See More';
    block.appendChild(btn);
  }

  function measure(block) {
    var inner = block.querySelector('.st-rm-inner');
    if (!inner || block.offsetParent === null) return;
    if (block.classList.contains('st-open')) return;
    setCls(block, 'st-has-more', inner.scrollHeight > clampH() + 40);
  }

  function apply(w) {
    var tabs = [].slice.call(w.querySelectorAll('.smart-tabs-navigation-li'));
    if (!tabs.length) return;
    w.setAttribute('data-st-init', '1');
    var cur = w._stCur || 0;
    if (cur >= tabs.length) cur = 0;
    w._stCur = cur;

    var blocks = [].slice.call(w.querySelectorAll('.smart-tabs-content-block'));
    tabs.forEach(function (t, i) {
      var on = i === cur;
      setCls(t, 'smart-tabs-navigation-li-active', on);
      setAttr(t, 'aria-selected', on ? 'true' : 'false');
      setAttr(t, 'aria-expanded', on ? 'true' : 'false');
      var id = t.getAttribute('aria-controls');
      blocks.forEach(function (b) {
        if (b.id !== id) return;
        setCls(b, 'st-show', on);
        setAttr(b, 'aria-hidden', on ? 'false' : 'true');
        setupMore(b);
        if (on) measure(b);
      });
    });
  }

  function applyAll() {
    document.querySelectorAll(W).forEach(apply);
  }

  var raf;
  function schedule() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(applyAll);
  }

  // Click: app ka handler rok do, apna chalao
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.st-rm-btn');
 if (btn) {
  var block = btn.closest('.smart-tabs-content-block');
  var open = block.classList.toggle('st-open');
  btn.textContent = open ? 'See Less' : 'See More';

  // When collapsing, scroll back to the top of this tab
  if (!open) {
    requestAnimationFrame(function () {
   var offset = 150; // Increase/decrease as needed

window.scrollTo({
  top: block.getBoundingClientRect().top + window.pageYOffset - offset,
  behavior: 'smooth'
});

      // Optional: offset for sticky header
      // const offset = 80;
      // window.scrollBy({ top: -offset, behavior: 'smooth' });
    });
  }

  return;
}
    var li = e.target.closest && e.target.closest(W + ' .smart-tabs-navigation-li');
    if (!li) return;
    var w = li.closest(W);
    var tabs = [].slice.call(w.querySelectorAll('.smart-tabs-navigation-li'));
    var i = tabs.indexOf(li);
    if (i < 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    w._stCur = i;
    apply(w);
    setTimeout(schedule, 60);
    setTimeout(schedule, 350);
  }, true);

  // App jab bhi class/aria/style badle, hum wapas single-tab state laga dein
  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-hidden', 'aria-selected', 'aria-expanded', 'style']
  });

  window.addEventListener('resize', function () {
    clearTimeout(window._stT);
    window._stT = setTimeout(schedule, 150);
  });
  window.addEventListener('load', function () { schedule(); setTimeout(schedule, 500); });
  document.addEventListener('DOMContentLoaded', schedule);
  schedule();
})();